module.exports = __webpack_public_path__ + "img/social_economy_details.557fb2c9.svg";